import { BrowserRouter, Route, Routes } from "react-router-dom";
import RouteScrollToTop from "./helper/RouteScrollToTop";
import PhosphorIconInit from "./helper/PhosphorIconInit";
import "animate.css/animate.min.css";
import allRoutes from "./routes";
import PrivateRoute from "./PrivateRoute";
import { Suspense } from "react";
import NotFound from "./components/common/NotFound";

function App() {
  return (
    <BrowserRouter>
      {/* <BrowserRouter> */}
      <Suspense fallback={<div className="pt-3 text-center" />}>
        <RouteScrollToTop />
        <PhosphorIconInit />

        <Routes>
          {allRoutes.routes.map(({ path, name, component: Component }) =>
            <Route key={name} path={path} element={<Component />} />
          )}
          <Route path="/" element={<PrivateRoute />}>
            {allRoutes.privateRoutes.map(
              ({ path, name, component: Component }) =>
                <Route key={name} path={path} element={<Component />} />
            )}
          </Route>
          {/* Optionally, add a fallback route for 404 Not Found */}
          <Route path="*" element={<NotFound/>} />
        </Routes>
      </Suspense>
    </BrowserRouter>
  );
}

export default App;
